import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../../services/app-data.service';

declare var Swiper: any;
declare var $:any;
@Component({
  selector: 'profile',
  templateUrl: './profile.html',
})
export class ProfileComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute

  ) {

  }
    public menuOpen=true;
    public menuConfig={};
    public items:any[] = [  ];
    public roomName='';
    public item;
    public interval;


    public posts;
    public followersNumber;
    public followingNumber;

  ngOnDestroy(): void {
      
  }
  openPicture(item){
    if (!this._appData.instagramUser){
      this._appData.page='social';
      $('#registerSocialModal').modal('show')
      this._appData.tiping=true;
      return;
    }

    //fecth room to show
      //começa botando o iframe visivel
      const modal0 = document.getElementById("iframeOfGameExt");
      modal0.style.visibility = "visible";    
      modal0['src']=item.video ? item.video : '';
      //e ligando o modal
      const modal = document.getElementById("social-modal");
      modal.style.display = "flex";     
      this._appData.socialRoom=item;
  
    if (item.kind=='link' && item.link && item.link.length>0){
      this._appData.room=item;
    }
    else{
    //pega detalhes da sala e do item
      this._companyService.getRoom(item.id).get().then((roomd) => {
        let room=roomd.data();
        let itens=[]
        this._companyService.getUserRoomItemRef(room.id).get().then(it=>{
              it.forEach(v=>{
                let item=v.data();
                itens.push(item)
              })
              room.userItens=itens;
              this._appData.room=room;


        });
      })
    }
    //update Views
    this._companyService.viewRoom(this._appData.instagramUser,item)
    this._companyService.getRoomCommentsRef(item.id).get().then((querySnapshot) => {
      let comments = [];
      querySnapshot.forEach((doc) => {
        let it = doc.data();
        comments.push(it);
      });
      this._appData.comments = comments;
    });
  }
  loadRoom(room){
              if ((room.background2d && room.background2d.length>0) || (room.background3d && room.background3d.length>0)){

                const modal3 = document.getElementById("iframeOfGame");
                modal3.style.visibility = "hidden";              

                const modal2 = document.getElementById("iframeOfGameimg");
                modal2.style.visibility = "visible";              
                const modal = document.getElementById("social-modal");
                modal.style.display = "flex";              

              }
              else{
                let modal3 = document.getElementById("iframeOfGame");
                modal3.style.visibility = "visible";              

                const modal4 = document.getElementById("iframeOfGameimg");
                modal4.style.visibility = "hidden";   
                const event = new CustomEvent('angularMessage',{detail:{kind:'reloadRoom',room:room}});
                window.dispatchEvent(event);
                const modal = document.getElementById("social-modal");
                modal.style.display = "flex";              

              }


  }
  public user;
  ngOnInit(): void {
    if (!this._appData.target) {
                this.user=this._appData.instagramUser;
                document.getElementById('userProfilePicture').style.backgroundImage = "url('"+this.user.profile_picture+"')"
                this.items=[];
                let link=''
                this._companyService.getSocialRoomRef().where('owner','==',this.user.uid).get().then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    let it=doc.data();
                    this.items.unshift(it);
                  });
                  this.posts=this.items.length
                  this.getFollows();
                }).catch((error) => {
                  console.error("Error getting documents: ", error);
                });

              }
      else{
        if (this._appData.target.company){
                this._companyService.getCompanyById(this._appData.target.uid).get().then((user) => {
                  let c=user.data();
                  this.user={
                    full_name:c.name,
                    profile_picture:c.thumbnail,
                    uid:c.dbId
                  }
                  document.getElementById('userProfilePicture').style.backgroundImage = "url('"+this.user.profile_picture+"')"
                  this.items=[];
                  let link=''
                  this._companyService.getSocialRoomRef().where('owner','==',this.user.uid).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                      let it=doc.data();
                      this.items.unshift(it);
                    });
                    this.posts=this.items.length
                    this.getFollows();
                  }).catch((error) => {
                    console.error("Error getting documents: ", error);
                  });

                });

        }
        else{
                this._companyService.getUserByUid(this._appData.target.uid).then((user) => {
                  this.user=user.data();
                  document.getElementById('userProfilePicture').style.backgroundImage = "url('"+this.user.profile_picture+"')"
                  this.items=[];
                  let link=''
                  this._companyService.getSocialRoomRef().where('owner','==',this.user.uid).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                      let it=doc.data();
                      this.items.unshift(it);
                    });
                    this.posts=this.items.length
                    this.getFollows();
                  }).catch((error) => {
                    console.error("Error getting documents: ", error);
                  });

                });
        
              }
        }
  }
  public following;
  public follows;
  public follow(){
    this._companyService.followUser(this._appData.instagramUser,this.user)
  }
  public getFollows(){
    this.following=[];
    this.follows=[]
    this._companyService.getFollowing(this.user).orderBy("full_name", "asc").get().then(snap=>{
      snap.forEach( userSnap =>{
        let user=userSnap.data();
        if (!user.profile_picture){
          user.profile_picture="https://liveplanet.app.br/assets/landingstyle/profile.png"
        }       
        this.following.push(user)
        this.followingNumber=this.following.length;
      })
    })
    this._companyService.getFollows(this.user).orderBy("full_name", "asc").get().then(snap=>{
      snap.forEach( userSnap =>{
        let user=userSnap.data();

        if (!user.profile_picture){
          user.profile_picture="https://liveplanet.app.br/assets/landingstyle/profile.png"
        }       
        this.follows.push(user)
        this.followersNumber=this.follows.length;
      })
    })

  }
 }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/social/profile/profile.ts